import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

export interface EditRowDataDialogData {
  productCode?: string;
  productDescription?: string;
  currentPrice?: number;
  unitPriceGross?: number;
  unitPriceGrossReference?: number;
  enabled?: boolean;
  favorite?: boolean;
  catalogPrice?: number;
  isFuel?: boolean;
  fccProductCode?:boolean;
}

@Component({
  selector: 'app-edit-row-data-dialog',
  templateUrl: './edit-row-data-dialog.component.html',
  styleUrls: ['./edit-row-data-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EditRowDataDialogComponent {
  form: FormGroup;
  isFuel: boolean;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<EditRowDataDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditRowDataDialogData
  ) {
    this.form = this.fb.group({
      enabled: [!!data?.enabled],
      favorite: [!!data?.favorite],
      unitPriceGross: [data?.unitPriceGross ?? 0, [Validators.required, Validators.min(0)]],
    });
    this.isFuel = data?.isFuel ?? false;
    if (this.isFuel) {
      this.form.get('unitPriceGross')?.enable();
    }else {
      this.disabledFields(!!data?.enabled);
      this.form.get('enabled')?.valueChanges.subscribe((isEnabled) => {
      this.disabledFields(isEnabled);
    });
    }
  }

  disabledFields(isEnabled: boolean) {
    const fields = ['favorite', 'unitPriceGross'];
    fields.forEach(field => {
      const control = this.form.get(field);
      if (isEnabled) {
        control?.enable();
      } else {
        control?.disable();
      }
    });
  }

  openDetail() {
    const detailCode = this.data.productCode
    if (detailCode) {
      return ["/products/product/", detailCode];
    }
  }

  save() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const valueForm = this.form.getRawValue();
    
    this.dialogRef.close({
      code: this.data.productCode,
      enabled: !!valueForm.enabled,
      favorite: !!valueForm.favorite,
      unitPriceGross: Number(valueForm.unitPriceGross),
      unitPriceNet: Number(this.data.catalogPrice),
      fccProductCode: this.data?.fccProductCode
    });
  }

  cancel() {
    this.dialogRef.close(null);
  }
}
